export const environment = {
  production: false,
  fptApiUrl: "https://fitprotracker-test.com/api",
};
